export default "__VITE_ASSET__BY3xmn3F__"